import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";

interface OttoHeaderProps {
  onNewConversation: () => void;
  onClose?: () => void;
  showCloseButton?: boolean;
}

export const OttoHeader = ({
  onNewConversation,
  onClose,
  showCloseButton = false,
}: OttoHeaderProps) => {
  return (
    <div className="flex items-center justify-between p-4 border-b border-border bg-primary text-primary-foreground">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-full bg-primary-foreground/20 flex items-center justify-center text-sm font-bold">
          O
        </div>
        <div>
          <h3 className="font-semibold">Otto</h3>
          <p className="text-xs opacity-80">Personal Assistant</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size={showCloseButton ? "icon" : "sm"}
          onClick={onNewConversation}
          className="text-primary-foreground hover:bg-primary-foreground/20 gap-1"
          title="New conversation"
        >
          <Icon name="add" size={16} />
          {!showCloseButton && "New"}
        </Button>
        {showCloseButton && onClose && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="text-primary-foreground hover:bg-primary-foreground/20 h-8 w-8"
          >
            <Icon name="close" size={16} />
          </Button>
        )}
      </div>
    </div>
  );
};
